module.exports = __webpack_public_path__ + "static/img/state2.7e230293.png";